import React, { useState } from "react";
import OrganizationHeader from "./Header";
import OrganizationSkeleton from "../../Skeleton/OrganizationSkeleton";
import OrganizationList from "./OrganizationList";

const OrganizationDashboard = () => {
  const [search, setSearch] = useState("");
  const [orgLength, setOrgLength] = useState(0);

  return (
    <>
      <div className="org-managment">
        <OrganizationHeader orgLength={orgLength} search={search} setSearch={setSearch} />

        <div className="team-functions">
          <div className="team-stats">
            <div className="org-tabs">
              <OrganizationList search={search} handleUpdateLength={(e) => setOrgLength(e) }/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrganizationDashboard;